module.exports = __webpack_public_path__ + "static/media/bg-home-top-right.53d3df86.png";